import { render, staticRenderFns } from "./WelcomBias.vue?vue&type=template&id=2e478a78&scoped=true&"
import script from "./WelcomBias.vue?vue&type=script&lang=js&"
export * from "./WelcomBias.vue?vue&type=script&lang=js&"
import style0 from "./WelcomBias.vue?vue&type=style&index=0&id=2e478a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e478a78",
  null
  
)

export default component.exports